import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'kt-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent implements OnInit, AfterViewInit {
  loading = false;

  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      themeColor:
        | 'primary'
        | 'secondary'
        | 'tertiary'
        | 'danger'
        | 'warning'
        | 'success'
        | 'neutral';
      iconPath: string;
      content: string;
      cancelLabel: string;
      confirmLabel: string;
    },
  ) {}

  ngOnInit(): void {
    this.loading = true;
  }

  ngAfterViewInit(): void {
    setTimeout(() => (this.loading = false));
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
